import { CalendarBlankIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Calendar = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <CalendarBlankIcon size={Sizes[size]} {...rest} />;
};

Calendar.displayName = 'Calendar';
